import { Component, OnInit, NgZone } from '@angular/core';
import { FileService } from '../../services/file.service';
import { DataTableModule, SharedModule } from 'primeng/primeng';

@Component({
  selector: 'app-download-log',
  templateUrl: './download-log.component.html',
  styleUrls: ['./download-log.component.css']
})
export class DownloadLogComponent implements OnInit {

  constructor(private _fileService: FileService, private zone: NgZone) { }

  public downloadList;
  ngOnInit() {
    const downloads = this._fileService.getDownloadList();
    downloads.subscribe(d => {
      this.zone.run(() => {
        // console.info(d);
        this.downloadList = d;
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/download-log/download-log.component.ts